const HEADER_SELECTOR = '[data-site-header="true"]';
const SECTION_SCROLL_GAP_PX = 16;

function resolveSectionElement(idOrElement) {
  if (typeof document === 'undefined') {
    return null;
  }

  if (typeof idOrElement === 'string') {
    return document.getElementById(idOrElement);
  }

  if (idOrElement && typeof idOrElement === 'object' && idOrElement.nodeType === 1) {
    return idOrElement;
  }

  return null;
}

export function getHeaderOffset() {
  if (typeof document === 'undefined') {
    return 0;
  }

  const header = document.querySelector(HEADER_SELECTOR);
  if (!header) {
    return 0;
  }

  const rect = header.getBoundingClientRect();
  return Math.ceil(rect.height + SECTION_SCROLL_GAP_PX);
}

export function setHeaderOffsetCssVar(headerElement) {
  if (!headerElement || typeof document === 'undefined') {
    return;
  }

  const height = Math.ceil(headerElement.getBoundingClientRect().height);
  document.documentElement.style.setProperty('--header-offset', `${height}px`);
}

export function scrollToSection(idOrElement) {
  if (typeof window === 'undefined') {
    return false;
  }

  const element = resolveSectionElement(idOrElement);
  if (!element) {
    return false;
  }

  const offset = getHeaderOffset();
  const top = window.scrollY + element.getBoundingClientRect().top - offset;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

  requestAnimationFrame(() => {
    if (!element.hasAttribute('tabindex')) {
      element.setAttribute('tabindex', '-1');
    }
    element.focus({ preventScroll: true });
  });

  return true;
}
